import EventManager from '../eventManager.mjs';
import { create, registerCustomElement } from '../utils.mjs';
import './banner.scss';
import { markdown } from '../markdown.mjs';

export class Banner extends HTMLElement {
	/**
	 * Builds the banner dom.
	 *
	 * @param instructions {{ text?: string; title?: string; badge?: string; theme?: 'normal' | 'dark' | 'error' | 'warning' | 'info'; closable?: boolean; buttons?: Array<{ label: string; event?: string; url?: string }>; }} Collection of directives.
	 */

	build(instructions) {
		if (instructions.theme === 'dark') {
			this.classList.add('dark');
		}

		if (instructions.theme === 'error') {
			this.classList.add('with-icon', 'error');

			const errorIcon = create(`i.fas.fa-triangle-exclamation`);
			this.appendChild(errorIcon);
		}

		if (instructions.theme === 'warning') {
			this.classList.add('with-icon', 'warning');

			const warningIcon = create(`i.fas.fa-hexagon-exclamation`);
			this.appendChild(warningIcon);
		}

		if (instructions.theme === 'info') {
			this.classList.add('with-icon', 'info');

			const infoIcon = create(`i.fas.fa-circle-info`);
			this.appendChild(infoIcon);
		}

		if (instructions.closable && instructions.closable === true) {
			const closeBtn = create('button.banner-close-btn');

			const crossIcon = create(`i.far.fa-times`);

			closeBtn.appendChild(crossIcon);

			this.appendChild(closeBtn);
		}

		if (instructions.badge) {
			const badges = create(`div.banner-badges`);

			badges.appendChild(create(`span ${instructions.badge}`));

			this.appendChild(badges);
		}

		const bannerContent = create('div.banner-content');

		if (instructions.title) {
			bannerContent.appendChild(create(`strong ${instructions.title}`));
		}
		if (instructions.text) {
			const bannerText = create(`.banner-text`);
			const bannerTextSpan = create('span');
			bannerTextSpan.innerHTML = markdown(instructions.text);
			bannerText.appendChild(bannerTextSpan);

			bannerContent.appendChild(bannerText);
		}

		this.appendChild(bannerContent);

		if (instructions.buttons) {
			const buttonsContainer = create('div.banner-buttons');
			instructions.buttons.forEach((button) => {
				const actionBtn = create('button.action-button');
				if (button.event) {
					actionBtn.textContent = button.label;
					actionBtn.addEventListener('click', () => EventManager.dispatch(this, button.event, { bubbles: true }));
				} else if (button.url) {
					const ahref = create('a');
					ahref.textContent = button.label;
					ahref.href = button.url;
					ahref.target = '_blank';
					actionBtn.appendChild(ahref);
				}
				buttonsContainer.appendChild(actionBtn);
			});
			this.appendChild(buttonsContainer);
		}
	}

	close() {
		this.remove();
	}

	connectedCallback() {
		setTimeout(() => {
			const closeBtn = this.querySelector('button.banner-close-btn');

			closeBtn?.addEventListener('click', () => this.close());
		});
	}
}

registerCustomElement('imt-visual-banner', Banner);
